exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#chapterSections .mdl-button{margin-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-5a7a1ff7!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SectionChapters.vue
// module id = 229
// module chunks = 0